/* eslint-disable */
import axios from "axios";
import store from "../../store";
import customModal from "../customModal/customModal.vue";
export default {
    components: {
        customModal
    },
    props: {
    subjectId: {
      type: String,
      required: true,

    },
  },
  data() {
    return {
      baseUrl: `${process.env.VUE_APP_Service_URL}/management/patient/`,
      baseapi: process.env.VUE_APP_Service_URL,
      randomization: {
        isRandomized: false,
        randomizationId: "",
        randomizationDate: "",
        kitNumber: "",
        status: "",
        milestone: ""
      },
      formErrors: {},
      statusList: [],
      milestoneList: [],
    };
  },
  mounted() {
    this.getSubjectStatus();
    this.getSubjectMilestones();
  },
  methods: {
  async saveRandomization() {
    this.formErrors = {};

    if (!this.randomization.isRandomized) {
    this.formErrors.isRandomized = "Please confirm randomization status";
    return;
  }
    if (this.randomization.isRandomized) {
      if (!this.randomization.randomizationId) {
        this.formErrors.randomizationId = "Randomization ID is required";
      }

      if (!this.randomization.randomizationDate) {
        this.formErrors.randomizationDate = "Date is required";
      }
      if (!this.randomization.kitNumber) {
        this.formErrors.kitNumber = "Kit Number is required";
      }
    }

    if (Object.keys(this.formErrors).length > 0) return;

    // Payload
    const payload = {
      subjectId: this.subjectId,
      isRandomized: this.randomization.isRandomized,
      randomizationId: this.randomization.randomizationId,
      kitNumber: this.randomization.kitNumber,
      randomizationDate: this.randomization.randomizationDate
        ? new Date(this.randomization.randomizationDate).toISOString()
        : null,
      status: this.randomization.status,
      milestone: this.randomization.milestone
    };

    console.log("Randomization Payload:", payload);

    const idtoken = store.getters.getIdToken;

    try {
      const res = await axios.put(
        `${this.baseapi}/management/patient/updaterandomizationdata`,
        payload,
        {
          headers: {
            Authorization: "Bearer " + idtoken,
            "Content-Type": "application/json"
          }
        }
      );

     alert("Randomization data saved successfully");

      this.$emit("refresh"); // optional
      this.closeModal();

    } catch (err) {
      console.error("Randomization API error:", err);

      if (err?.response?.data?.detail) {
        alert(err.response.data.detail);
      }
    }
  },
  async getSubjectStatus() {
      const idtoken = store.getters.getIdToken;

      const res = await axios.get(
        `${this.baseapi}/management/statusmaster/getall?StatusType=Subject`,
        {
          headers: {
            Authorization: "Bearer " + idtoken,
          },
        }
      );

      this.statusList = res.data;
  },
  async getSubjectMilestones() {
      const idtoken = store.getters.getIdToken;
      let studyId = store.getters.getStudyIs;

      const res = await axios.get(
        `${this.baseapi}/management/patient/listsubjectmilestone?studyId=${studyId}`,
        {
          headers: {
            Authorization: "Bearer " + idtoken,
          },
        }
      );

      this.milestoneList = res.data.data || [];
    },

  closeModal() {
    this.$emit("closeModal");
  }
}
};